import React, { useState } from 'react'
import { Nav, Tab } from 'react-bootstrap';
import PayoutHistory from './PayoutHistory';
import EarningsPayouts from './EarningsPayouts';



const NavTabEarning = () => {
    const [active, setActive] = useState({
        first: true,
        second: false,
        third: false,
        fourth: false,
        six: false,
        fifth: false,
        seven: false,
        eigtht: false,
    })
    const handleActive = (type) => {
        let keyArr = Object.keys(active)
        let arr = { ...active }
        keyArr.forEach((curElem) => {
            if (curElem === type) {
                arr[curElem] = true

            } else {
                arr[curElem] = false
            }
        })
        setActive(arr)
    }

    return (
        <>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <div className="row" >
                    <div className="col-12">
                        <Nav variant="pills" style={{ padding: "10px 28px 15px 6px" }} >
                            <Nav.Item onClick={() => handleActive("first")}>
                                <Nav.Link className={active.first ? "active" : ""}> My Earnings</Nav.Link>
                            </Nav.Item>
                            <Nav.Item onClick={() => handleActive("second")}>
                                <Nav.Link className={active.second ? "active" : ""}>Payout History</Nav.Link>
                            </Nav.Item>

                        </Nav>

                    </div>

                    <div className="col-12">
                        <div className="setting_right_side_wrap">
                            <Tab.Content>
                                <Tab.Pane className={active.first ? "active show" : ""}>
                                    <EarningsPayouts first={active.first} />
                                </Tab.Pane>
                                <Tab.Pane className={active.second ? "active show" : ""}>
                                    <PayoutHistory second={active.second} />
                                </Tab.Pane>


                            </Tab.Content>
                        </div>
                    </div>
                </div>
            </Tab.Container >
        </>
    )
}

export default NavTabEarning
